import { render, staticRenderFns } from "./CatalogProductSettingClothing.vue?vue&type=template&id=42f5f9e6&scoped=true&"
import script from "./CatalogProductSettingClothing.vue?vue&type=script&lang=js&"
export * from "./CatalogProductSettingClothing.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductSettingClothing.vue?vue&type=style&index=0&id=42f5f9e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f5f9e6",
  null
  
)

export default component.exports